// src/components/CameraCapture.tsx
import { motion } from 'framer-motion'
import { Button } from './ui/Button'
import { useCamera } from '../hooks/useCamera'

interface CameraCaptureProps {
  onCapture: (base64: string) => void
  label?: string
}

export function CameraCapture({ onCapture, label = 'Fota' }: CameraCaptureProps) {
  const { photo, error, capturePhoto, handleFileChange, clearPhoto, inputRef } = useCamera()

  const handleConfirm = () => {
    if (photo) {
      onCapture(photo)
      clearPhoto()
    }
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFileChange}
        className="hidden"
      />

      {photo ? (
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="flex flex-col items-center gap-3"
        >
          <img
            src={photo}
            alt="Taget foto"
            className="w-48 h-48 object-cover rounded-2xl shadow-md"
          />
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={clearPhoto}>
              Ta om
            </Button>
            <Button size="sm" onClick={handleConfirm}>
              Använd
            </Button>
          </div>
        </motion.div>
      ) : (
        <Button variant="secondary" size="lg" onClick={capturePhoto} className="w-full">
          {label}
        </Button>
      )}

      {error && <p className="text-coral font-body text-sm">{error}</p>}
    </div>
  )
}
